module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "contact-form-page"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6 col-sm-6"
  }, [_c('label', {
    directives: [{
      name: "lang",
      rawName: "v-lang.name",
      modifiers: {
        "name": true
      }
    }],
    staticClass: "control-label"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.name),
      expression: "contacto.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": _vm.tr('enter_name')
    },
    domProps: {
      "value": (_vm.contacto.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6"
  }, [_c('label', {
    directives: [{
      name: "lang",
      rawName: "v-lang.phone",
      modifiers: {
        "phone": true
      }
    }],
    staticClass: "control-label"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.phone),
      expression: "contacto.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": _vm.tr('enter_phone')
    },
    domProps: {
      "value": (_vm.contacto.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6"
  }, [_c('label', {
    directives: [{
      name: "lang",
      rawName: "v-lang.email",
      modifiers: {
        "email": true
      }
    }],
    staticClass: "control-label"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.email),
      expression: "contacto.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": _vm.tr('enter_email')
    },
    domProps: {
      "value": (_vm.contacto.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6 col-sm-6"
  }, [_c('label', {
    directives: [{
      name: "lang",
      rawName: "v-lang.subject",
      modifiers: {
        "subject": true
      }
    }],
    staticClass: "control-label"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.subject),
      expression: "contacto.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subject",
      "placeholder": _vm.tr('enter_subject')
    },
    domProps: {
      "value": (_vm.contacto.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.subject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    directives: [{
      name: "lang",
      rawName: "v-lang.message",
      modifiers: {
        "message": true
      }
    }],
    staticClass: "control-label"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.message),
      expression: "contacto.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": _vm.tr('enter_message')
    },
    domProps: {
      "value": (_vm.contacto.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('button', {
    staticClass: "button  btn_blue mt40 upper pull-right",
    class: {
      'disabled': !_vm.valid
    },
    attrs: {
      "disabled": !_vm.valid,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.send($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.send_message",
      modifiers: {
        "send_message": true
      }
    }]
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cfa6173"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactForm/Extend.vue
// module id = 355
// module chunks = 0